import { React, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
// import SearchResults from '../../Utils/SearchResults';
import {
  Container,
  Button,
  Alert,
  Form,
  FormGroup,
  Col,
  Input,
} from "reactstrap";
// import { connect } from "react-redux";
import errors from "../../Constants/errors.json";
import Mapping from "../../Utils/Mapping";
import * as requestActions from "../../../actions/request";
import { Loading } from "../../../loader/Loading";
import RejectedDetails from "./RejectedDetails";
import DocumentTitle from "react-document-title";
import { FaEquals } from "react-icons/fa";
// import InfiniteScrollTable from './InfiniteScrollTable';
import InfiniteScrollTable from "../../Common/InfiniteScrollTable";
import { enAPI } from "../../../config";

function RejectedList() {
  const dispatch = useDispatch();
  const { rejectedList, rejectedInfo, success, lastKey, deleted_status } =
    useSelector((state) => state?.requests);
  const error = useSelector((state) => state?.error?.error_obj);
  const authToken = useSelector((state) => state?.auth?.token);
  const app = useSelector((state) => state?.pool?.userPool);
  const isLoading = useSelector((state) => state?.fetch?.isLoading);

  const [currState, setCurrState] = useState({
    modal: false,
    property: undefined,
    attribute_value: null,
    attibute_name: null,
  });

  const PropertySet = (value) => {
    clearRejectedInfoFn();
    setCurrState((prevState) => {
      return {
        ...prevState,
        property: value,
      };
    });
    toggle();
  };

  const toggle = () => {
    setCurrState({ ...currState, modal: !currState?.modal });
  };

  useEffect(() => {
    dispatch({ type: "RESET_ERROR" });
    dispatch({ type: "RESET_REQUEST" });
    return () => {
      dispatch({ type: "RESET_ERROR" });
      dispatch({ type: "RESET_REQUEST" });
    };
  }, [dispatch]);

  const { attribute_name, attribute_value } = currState;
  const filterOptions = [
    { value: "", label: "Select the criteria" },
    { value: "email", label: "Email ID" },
    { value: "custom_company", label: "Company" },
  ];

  const cols = [
    {
      label: "Email",
      dataKey: "email",
      width: "250",
      customCell: (props) => {
        const { rowData } = props;
        return (
          <div
            style={{
              color: "blue",
              cursor: "pointer",
              // height: '36px',
              // width: '300px'
            }}
            onClick={(e) => {
              PropertySet(rowData);
              getRejectedInfoFn(rowData.email, rowData.rejected_date);
            }}
          >
            {rowData.email}
          </div>
        );
      },
      // width: '40%',
    },
    {
      label: "Rejection Date",
      dataKey: "rejected_date",
      // width: '20%',
      width: "250",
      customCell: (props) => {
        const { rowData } = props;
        return (
          <div
            style={{
              // height: '36px',
              // width: '300px',
              border: "none",
              // backgroundColor: '#edeef3',
            }}
          >
            {rowData.rejected_date}
          </div>
        );
      },
    },
    {
      label: "Company",
      dataKey: "company",
      // width: '20%',
      width: "250",
      customCell: (props) => {
        const { rowData } = props;
        return (
          <div
            style={{
              height: "36px",
              width: "300px",
              border: "none",
              // backgroundColor: '#edeef3',
            }}
          >
            {rowData.company}
          </div>
        );
      },
    },
  ];

  // useEffect(() => {
  //   return () => {
  //     dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
  //   };
  // }, []);

  const optionList = (options) => {
    return options.map((opt, i) => {
      return (
        <option value={opt.value} key={i}>
          {opt.label}
        </option>
      );
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    getRejectedListFn(attribute_name, attribute_value);
  };

  var errorMessage =
    (error && error.code && error.code.message && error.code.message.code) ||
    (error && error.message) ||
    (error && <Mapping dictionary={errors} word={error.errorPath} />);

  let emailExists =
    error && error.message === "User with given email already exists";
  let searchAttributes =
    attribute_name === "email"
      ? { email: attribute_value }
      : { custom_company: attribute_value };

  const getRejectedListFn = (...props) => {
    dispatch({ type: "RESET_REQUEST" });
    dispatch(requestActions.getRejectedList(...props));
  };
  // const clearRejectedListFn = () => {
  //   dispatch({ type: "RESET_ERROR" });
  //   dispatch({ type: "RESET_REQUEST" });
  // };
  const getRejectedInfoFn = (email, rejectedDate) => {
    dispatch(requestActions.getRejectedInfo(email, rejectedDate));
  };
  const clearRejectedInfoFn = () => {
    dispatch(requestActions.clearRejectedInfo());
  };
  const errorWhileFetchFn = (err) =>
    dispatch(requestActions.errorWhileFetch(err));
  const fetchCompleteFn = (...props) =>
    dispatch(requestActions.fetchComplete(...props));
  // setDeleteStatus: () => dispatch(requestActions.setDeleteStatus()),
  const setRejectedListFn = (...props) =>
    dispatch(requestActions.setRejectedList(...props));

  return (
    <>
      <DocumentTitle title={`Doorkeeper | Rejection History`}></DocumentTitle>
      <Container style={{ padding: "0% 2%" }}>
        <h5 style={{ marginLeft: "42%" }}>Rejection History</h5>
        {currState?.modal && rejectedInfo && (!error || emailExists) && (
          <RejectedDetails
            MainModal={currState?.modal}
            MainToggle={toggle}
            rowDetails={currState?.property}
            attributeName={attribute_name}
            attributeValue={attribute_value}
          />
        )}
        {success && !isLoading && (
          <Alert color="success" style={{ marginBottom: "0px" }}>
            <h6>{success}</h6>
          </Alert>
        )}
        <Container
          style={{
            border: "3px solid #ddd",
            padding: "1% 3%",
          }}
        >
          <Form onSubmit={handleSubmit}>
            <FormGroup row style={{ margin: "0 0 0 0" }}>
              <Col sm="4">
                <Input
                  type="select"
                  name="attribute_name"
                  value={attribute_name}
                  onChange={(e) => {
                    setCurrState((prevState) => {
                      return {
                        ...prevState,
                        attribute_name: e.target.value,
                      };
                    });
                  }}
                >
                  {optionList(filterOptions)}
                </Input>
              </Col>
              <Col sm="1">
                <span
                  style={{
                    fontSize: "20px",
                    marginLeft: "25%",
                  }}
                >
                  <FaEquals />
                </span>
              </Col>
              <Col sm="4">
                <Input
                  type="text"
                  name="attribute_value"
                  value={attribute_value}
                  onChange={(e) =>
                    setCurrState({
                      ...currState,
                      attribute_value: e.target.value,
                    })
                  }
                />
              </Col>
              <Col sm="2">
                <Button
                  style={{ float: "left" }}
                  type="submit"
                  disabled={!attribute_value || !attribute_name}
                >
                  Search
                </Button>
              </Col>
            </FormGroup>
          </Form>
        </Container>
        {isLoading && !error && <Loading />}
        {/* {rejectedList && rejectedList.length > 0 && (!error || emailExists) && (
						  <SearchResults
							  columns={columns}
							  data={rejectedList}
							  tableHeight={'50vh'}
						  />
					  )} */}
        {rejectedList && rejectedList.length > 0 && (!error || emailExists) && (
          <InfiniteScrollTable
            columnData={cols}
            data={rejectedList}
            gridClassName={"gridClass"}
            rowHeight={45}
            page={"rejectedHistory"}
            url={`${enAPI}${app}/getrejectedrequests`}
            // url={'http://localhost:5000/api/idm/admin/DS/getrejectedrequests'}
            lastKey={lastKey}
            authToken={authToken}
            searchAttributes={searchAttributes}
            errorWhileFetch={errorWhileFetchFn}
            fetchComplete={fetchCompleteFn}
            deleted_status={deleted_status}
            setRejectedList={setRejectedListFn}
          />
        )}
        {!error && rejectedList && rejectedList.length === 0 && !isLoading && (
          <Alert color="info" style={{ textAlign: "center" }}>
            <h6>No records found.</h6>
          </Alert>
        )}
        {error && !emailExists && (
          <Alert color="danger" style={{ textAlign: "center" }}>
            <h5>{errorMessage}</h5>
          </Alert>
        )}
      </Container>
    </>
  );
}

export default RejectedList;
